/**
 * @generated SignedSource<<234f3f2dba60ee42a59ab9182d7ec48d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanelItemModuleDescription_item$data = {
  readonly seoDescription: string | null;
  readonly " $fragmentType": "PdpRespAboutItemPanelItemModuleDescription_item";
};
export type PdpRespAboutItemPanelItemModuleDescription_item$key = {
  readonly " $data"?: PdpRespAboutItemPanelItemModuleDescription_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanelItemModuleDescription_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanelItemModuleDescription_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seoDescription",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3423ff0f553e3cff9d62f516955117fb";

export default node;
